import { render, staticRenderFns } from "./HpadD_Total.vue?vue&type=template&id=72dfda3e"
import script from "./HpadD_Total.vue?vue&type=script&lang=js"
export * from "./HpadD_Total.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports